<template>
  <div
    :class="['search', { 'search--open': showSearch, 'search--focus': focus }]"
  >
    <div class="search__inner">
      <el-input
        type="search"
        v-model="searchValue"
        placeholder="Search"
        @focus="handleFocus"
        @blur="handleBlur"
      />
      <i class="el-icon-search" @click="handleOpenSearch" />
      <i class="el-icon-close" @click="handleCloseSearch" />
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      searchValue: "",
      showSearch: false,
      focus: false
    };
  },
  methods: {
    handleOpenSearch() {
      this.showSearch = true;
    },
    handleCloseSearch() {
      this.showSearch = false;
    },
    handleFocus() {
      this.focus = true;
    },
    handleBlur() {
      this.focus = false;
    }
  },
  watch: {
    searchValue: function() {
      this.$store.dispatch("datasets/setSearch", this.searchValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  position: relative;
  z-index: 10;
  @include media("<navbar-sm") {
    position: absolute;
    top: 100%;
    right: 0;
    left: calc(100% - 27px);
    overflow: hidden;
    background: white;
    transform: translateY(-3px);
    transition: left 0.3s ease;
  }

  ::v-deep {
    .el-input__inner {
      padding: 0 0 0 em(27, 14);
      width: 330px;
      max-width: 100%;
      height: rem(30);
      line-height: rem(30);
      border-radius: 0;
      border-top: none;
      border-right: none;
      border-left: none;
      background: transparent;
      @include media("<navbar-sm") {
        padding-left: em(38, 16);
        font-size: rem(16);
        border-bottom: none;
      }

      &::placeholder {
        color: $--color-text-light;
      }
    }
  }
}

.search__inner {
  position: relative;
  min-width: 100px;
}

.search--open {
  @include media("<navbar-sm") {
    left: 0;
  }
}

.search--focus {
  .el-icon-search {
    color: $--color-primary;
  }
}

.el-icon-close,
.el-icon-search {
  font-size: rem(20);
  line-height: 1;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: $--color-text-light;
  @include media("<navbar-sm") {
    font-size: rem(25);
    z-index: 10;
    cursor: pointer;
  }
}

.el-icon-search {
  transition: color 0.3s ease;

  @include media("<navbar-sm") {
    transform: translateY(-55%);
  }
}

.el-icon-close {
  font-size: rem(30);
  display: none;
  left: auto;
  right: 0;
  @include media("<navbar-sm") {
    display: block;
  }
}
</style>
